
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 500 500"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M233.8 46.9c-103.2 0-186.9 83.7-186.9 186.9s83.7 186.9 186.9 186.9c51.6 0 98.3-20.9 132.2-54.8s54.8-80.6 54.8-132.2c0-103.1-83.7-186.8-187-186.8zM0 233.8C0 104.7 104.7 0 233.8 0 363 0 467.6 104.7 467.6 233.8c0 56.1-19.8 107.6-52.7 147.9l78.2 78.2c9.2 9.2 9.2 24 0 33.1-9.2 9.2-24 9.2-33.1 0l-78.2-78.2c-40.3 32.9-91.8 52.7-147.9 52.7C104.7 467.6 0 363 0 233.8z"}})])
          )
        }
      }
    